/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  SET_CONTACT_TO_ADD
} from '../actions/actionTypes';

const initialState = {
  contact: null,
}
export default function (state = initialState, action) {
  switch (action.type) {
      case SET_CONTACT_TO_ADD:
      return {
        contact: action.payload,
      }
      default:
        return state;
  }
}